// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Module-scoped styles for DepositTab */
.nA8ReroYd639k35a2mch {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--help-container-content-color);
}
.szU1dmCdaTCzg3Yxyh8q {
  line-height: 1.5em;
  text-align: center;
  padding: 8px;
  width: 100%;
  max-width: 623px;
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/features/settings/components/Deposit/DepositTab.module.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["/* Module-scoped styles for DepositTab */\n.container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--help-container-content-color);\n}\n.message {\n  line-height: 1.5em;\n  text-align: center;\n  padding: 8px;\n  width: 100%;\n  max-width: 623px;\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `nA8ReroYd639k35a2mch`,
	"message": `szU1dmCdaTCzg3Yxyh8q`
};
export default ___CSS_LOADER_EXPORT___;
